import { api } from "@/lib/api";
import type { OrgRole, Person } from "@/features/session/types";

export interface PersonCreate {
  email: string;
  name: string;
  org_role: "admin" | "member";
}

export const peopleApi = {
  list: () => api.get<Person[]>("/people"),
  add: (payload: PersonCreate) => api.post<Person>("/people", payload),
  setOrgRole: (sub: string, org_role: OrgRole) => api.patch<Person>(`/people/${sub}`, { org_role }),
  offboard: (sub: string) => api.delete(`/people/${sub}`),
};

export const peopleKeys = {
  all: ["people"] as const,
  list: () => [...peopleKeys.all, "list"] as const,
};
